module.exports = __webpack_public_path__ + "img/noFilter.8f1e40d8.svg";